import EntityModel from '@/common/models/entity-model';

export default class RuleActionModel extends EntityModel {
    static Statuses = {
        active: 'active',
        inactive: 'inactive',
    };

    hydrate({
        name = null,
        status = 'active',
    } = {}) {
        this.name = name;
        this.status = RuleActionModel.convertStringStatus(status);
    }

    getPayload() {
        return {
            name: this.name,
            status: RuleActionModel.convertBooleanStatus(this.status),
        };
    }

    static Names = {
        addNsfFee: 'add-nsf-fee',
        addRiskScore: 'add-risk-score',
        blacklist: 'blacklist',
        cancelScheduledPayments: 'cancel-scheduled-payments',
        displayOtherChoices: 'display-other-choices',
        guessPaymentCardExpiration: 'guess-payment-card-expiration',
        offerPurchaseBump: 'offer-purchase-bump',
        pickGatewayAccount: 'pick-gateway-account',
        requestKyc: 'request-kyc',
        scheduleInvoiceRetry: 'schedule-invoice-retry',
        schedulePayment: 'schedule-payment',
        schedulePaymentRetry: 'schedule-payment-retry',
        sendEmail: 'send-email',
        showDescriptorDisclaimer: 'show-descriptor-disclaimer',
        stopSubscriptions: 'stop-subscriptions',
        churnSubscription: 'churn-subscription',
        tagOrUntagCustomer: 'tag-or-untag-customer',
        triggerWebhook: 'trigger-webhook',
        scheduleReminder: 'schedule-reminder',
        resetReminder: 'reset-reminder',
        removeReminder: 'remove-reminder',
        createKeapInfusionsoftOrder: 'create-keap-infusionsoft-order',
        createKeapInfusionsoftPayment: 'create-keap-infusionsoft-payment',
    };
}
